import { stripControlChars } from './stripControlChars';

/** 
 * Recursively strips XML-illegal control chars from every string.
 * Rebuilds objects and arrays, does not mutate input.
 * */
export const stripControlCharsInObject = <T>(value: T): T => {
  if (value === null || value === undefined) {
    return value;
  }

  if (typeof value === 'string') {
    return stripControlChars(value) as T;
  }

  if (Array.isArray(value)) {
    return value.map((item) => stripControlCharsInObject(item)) as T;
  }

  if (typeof value === 'object') {
    const result: Record<string, any> = {};
    for (const [key, val] of Object.entries(value)) {
      result[key] = stripControlCharsInObject(val);
    }
    return result as T;
  }

  return value;
};
